module.exports = __webpack_public_path__ + "static/media/pph.a7ccf3a6.jpg";